import axios from "axios";

const apiurl = process.env.REACT_APP_API_URL;

export const GetAndCreateCategory = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post category data from API
        url:`${apiurl}LADProducts/categories/`,
        data:data
    })
}

export const GetAndCreateSubCategory = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Sub category data from API
        url:`${apiurl}LADProducts/subcategories/`,
        data:data
    })
}
export const DeleteCategory = async(method,id,data)=>{
    return axios({
        method:method,                                         // This is used to get and post category data from API
        url:`${apiurl}LADProducts/categories/${id}/`,
        data:data
    })
}

export const DeleteSubCategory = async(method,id,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Sub category data from API
        url:`${apiurl}LADProducts/subcategories/${id}/`,
        data:data
    })
}

export const SearchCategory = async(method,searchTerm)=>{
    try {
        const url = `${apiurl}/LADProducts/category-search/?search=${encodeURIComponent(searchTerm)}`;

        const response = await axios({
            method: method,                                                // This is used to get search category from API
            url: url,
            maxRedirects: 0,  // Prevent automatic redirects
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const ImportCategory = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to import a file Sub category data from API
        url:`${apiurl}LADProducts/import-categories/`,
        data:data
    })
}

export const BulkCategoryDelete = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to import a file Sub category data from API
        url:`${apiurl}LADProducts/category_bulk-delete/`,
        data:data
    })
}

